import React from 'react';
import {
  useFirebaseContext,
  useAllInOneContext,
  useActiveListContext,
} from '../../../context';
import { getTaskCount } from '../../../helpers';
import { timestamp } from '../../../lib';
import { Archive } from './styles';

export const Checkbox = ({
  isInDelete,
  setIsInDelete,
  setProgress,
  task,
  targetTask,
  setTargetTask,
}) => {
  const { firebase } = useFirebaseContext();
  const {
    lists,
    setLists,
    allTasks,
    setAllTasks,
    setMaxModifiedAt,
  } = useAllInOneContext();
  const { activeList, setActiveList, themeColor } = useActiveListContext();

  const deleteTask = () => {
    const targetList = task.listID;
    const targetOrder = task.order;
    const tempModifiedAt = timestamp.now().toMillis();
    setProgress(20);

    const userDB = firebase
      .firestore()
      .collection('users')
      .doc(firebase.auth().currentUser.uid);
    const taskDB = userDB.collection('tasks');

    const tempLists = lists;
    const index = tempLists.findIndex((item) => item.docID == targetList);
    setProgress(60);

    let temp = getTaskCount(targetList, lists) - 1;
    userDB
      .collection('lists')
      .doc(targetList)
      .update({ taskCount: temp, modifiedAt: tempModifiedAt });
    tempLists[index].taskCount = temp;
    tempLists[index].modifiedAt = tempModifiedAt;
    setProgress(95);

    taskDB
      .doc(task.docID)
      .delete()
      .then(() => {
        setProgress(100);
        let tempTasks = allTasks.filter((item) => item.docID != task.docID);
        tempTasks
          .filter(
            (item) => item.listID == targetList && item.order > targetOrder
          )
          .map((doc) => {
            taskDB.doc(doc.docID).update({
              order: doc.order - 1,
              modifiedAt: tempModifiedAt,
            });

            doc.order = doc.order - 1;
            doc.modifiedAt = tempModifiedAt;
          });

        setIsInDelete(false);
        setLists(tempLists);
        setAllTasks(tempTasks);
        setTargetTask();

        setActiveList();
        setActiveList(activeList);

        setMaxModifiedAt(tempModifiedAt);
      });
  };

  return (
    <Archive
      color={themeColor}
      isInDelete={targetTask == task.docID && isInDelete}
      onClick={() => {
        setTargetTask(task.docID);
        setIsInDelete(true);
        deleteTask();
      }}
    >
      <div></div>
    </Archive>
  );
};
